module.exports = __webpack_public_path__ + "img/Bastiaan.597afeb5.jpg";